module.exports = __webpack_public_path__ + "fonts/font.15d97e4.woff";